const reportError = (error) => {
	console.error(error)
}

export default reportError
